/**
 * Client-side search for lists whose full dataset is already loaded: keeps the
 * items whose searchable text contains `searchText`, ignoring case and
 * surrounding whitespace. A blank search returns `items` itself, so memoized
 * consumers keep a stable reference.
 */
export const filterBySearchText = <T>(
	items: T[],
	searchText: string,
	getSearchableText: (item: T) => string,
): T[] => {
	const query = searchText.trim().toLowerCase();

	if (!query) {
		return items;
	}

	return items.filter((item) =>
		getSearchableText(item).toLowerCase().includes(query),
	);
};
